export const decodeSearchtextString = (text: string): string => {
  try {
    const decodedText = decodeURIComponent(text);
    return decodedText;
  } catch (e) {
    return text;
  }
};
